module.exports = __webpack_public_path__ + "static/media/M1.cf3e9e3d.jpg";